import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-inline-edit',
  templateUrl: './inline-edit.component.html',
  styleUrls: ['./inline-edit.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InlineEditComponent),
      multi: true
    }
  ]
})
export class InlineEditComponent implements ControlValueAccessor {
  // Ahora soporta 4 tipos de inputs
  @Input() type: 'text' | 'textarea' | 'date' | 'ngselect' | 'select' | 'boolean' | 'switch' = 'text';
  @Input() placeholder: string = '';
  @Input() inputClass: string = '';
  @Input() modoEditar: boolean = false;
  
  // Array de opciones para cuando el tipo sea 'select'
  // Puede ser un array de strings ['Opción 1', 'Opción 2'] o de objetos
  @Input() options: any[] = []; 

  value: any = ''; // Cambiado a 'any' para soportar booleanos
  editando: boolean = false;
  valorTemporal: any = '';

  onChange: any = () => {};
  onTouch: any = () => {};

  activarEdicion() {
    if (!this.modoEditar)
      return;
    // Si es booleano, cambiamos el valor directamente al hacer click sin abrir un input
    if (this.type === 'boolean') {
      this.value = !this.value;
      this.onChange(this.value);
      return;
    }
    
    this.valorTemporal = this.value;
    this.editando = true;
  }

  guardarCambios() {
    this.editando = false;
    
    // Validamos cambios según el tipo de dato
    const nuevoValor = typeof this.valorTemporal === 'string' 
      ? this.valorTemporal.trim() 
      : this.valorTemporal;

    if (nuevoValor !== this.value) {
      this.value = nuevoValor;
      this.onChange(this.value);
    }
  }

  writeValue(value: any): void { this.value = value; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }
}